const formatDateWithLocale = (date, locale, options) => date
  ?.toLocaleString(locale, {
    timeZone: 'UTC',
    ...options,
  });

export default formatDateWithLocale;
